import { useEffect, useState } from "react";
import axios from "../axios";
import { useAbortController } from "./useAbortController";
import urls from "../Utils/urls";

const usePaymentActivity = (loanId) => {
  const [paymentActivity, setPaymentActivity] = useState(null);
  const [error, setError] = useState(false);
  const [retryCount, setRetryCount] = useState(0);
  const { signal } = useAbortController();

  useEffect(() => {
    let ignore = false;
    setPaymentActivity(null);
    setError(false);
    const fetchData = async () => {
      try {
        const res = await axios.get(urls.borrower.getPaymentActivity(loanId), {
          signal,
        });
        const data = res?.data?.[0] || [];
        if (!ignore) {
          setPaymentActivity(data);
        }
      } catch (requestError) {
        if (!ignore) {
          console.error(`Payment History failed for loan ${loanId}`, requestError);
          setError(true);
        }
      }
    };
    fetchData();
    return () => {
      ignore = true;
    };
  }, [loanId, retryCount, signal]);

  const retry = () => {
    setError(false);
    setPaymentActivity(null);
    setRetryCount((count) => count + 1);
  };

  return { error, paymentActivity, retry };
};

export default usePaymentActivity;
